import {
  BMComponentsType,
  BMPrimitives,
  useBMTheme,
} from "@traveloka/district-bloom";
import { StyleSheet } from "react-native";

import { MenuList } from "./MenuList";
import { MenuGroupProps } from "./types";

import BMView from "../../../components/View/BMView";

export default function MenuGroup({ data }: MenuGroupProps) {
  const { BMComponents } = useBMTheme();
  const styles = createStyles(BMComponents);
  return (
    <BMView style={styles.container}>
      {data.map((item, index) => (
        <BMView key={`menu-group-${index}`}>
          {index > 0 && <BMView style={styles.divider} />}
          <MenuList {...item} />
        </BMView>
      ))}
    </BMView>
  );
}

const createStyles = (BMComponent: BMComponentsType) => {
  return StyleSheet.create({
    container: {
      marginVertical: BMPrimitives.BMSize.sm,
    },
    divider: {
      marginVertical: BMPrimitives.BMSize.sm,
      borderBottomWidth: BMPrimitives.BMBorder.width.thick,
      borderBottomColor: BMComponent.BMStyleLineBordercolorSubtle,
    },
  });
};
